import { useSelector, useDispatch } from "react-redux";
import {
  useGetProductVariantListDataQuery,
  useUpdateProductVariantTableHeadDataMutation,
} from "../../../../../store/queries/Product";
import { updateConfig } from "../../../../../store/slices/Admin/Product/productVariantSlice";
import { updateConfig as globalUpdateConfig } from "../../../../../store/slices/Global";
import { useParams } from "react-router-dom";
import { IconText } from "@wac-ui-dashboard/wac_component_library";
import { useState } from "react";

const useVariants = (customerKey) => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { product_id } = useParams();
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageData, setImageData] = useState("");
  const activeProfile = product_id ?? sessionStorage.getItem("active");
  const productVariantState = useSelector((state) => state.productVariant);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const {
    data: productVariantList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetProductVariantListDataQuery({
    customer_key: customerKey,
    product_id: activeProfile,
    page_size: productVariantState?.currentPageSize,
    page: productVariantState?.currentPage,
    sort: productVariantState?.sortBy,
    sort_order: productVariantState?.sortOrder,
    search: productVariantState?.search,
  });
  const [updateVariantFields] = useUpdateProductVariantTableHeadDataMutation();
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e?.target?.value;
        state.currentPage = 1;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (productVariantState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            productVariantState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.image)}
            />
          </div>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleViewImage = (data) => {
    setShowImageModal(() => true);
    setImageData(data);
  };
  const closeImageModal = () => {
    setShowImageModal(() => false);
    setImageData("");
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };

  return {
    isLoading,
    imageData,
    isFetching,
    tableFields,
    showEditModal,
    showImageModal,
    paginationOptions,
    productVariantList,
    productVariantState,
    handleEditColumnsClick,
    updateVariantFields,
    handlePagination,
    handleClearClick,
    handlePageSize,
    closeImageModal,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useVariants;
